import { ComponentProps } from 'react';
import { MenuTrigger } from './menu-trigger';
import { MenuV1 } from './menu-v1';
import './menu.scss';

type Props = ComponentProps<typeof MenuTrigger>;

export const MenuButton = (props: Props) => {
    return (
        <MenuTrigger {...props}>
            <MenuV1 />
        </MenuTrigger>
    );
};
